export const SubscriptionActions = {
  APPLY_CHURN_DISCOUNT: 'SUBSCRIPTION_APPLY_CHURN_DISCOUNT',
  CONFIRM_CANCEL_SUBSCRIPTION: 'CONFIRM_CANCEL_SUBSCRIPTION',
  REMOVE_CANCEL_SUBSCRIPTION_CONFIRMATION: 'REMOVE_CANCEL_SUBSCRIPTION_CONFIRMATION',
  LOAD_AVAILABLE_PLANS: 'SUBSCRIPTION_LOAD_AVAILABLE_PLANS',
  PAY_SUBSCRIPTION: 'SUBSCRIPTION_PAY',
  CONTINUE_CURRENT_PLAN: 'CONTINUE_CURRENT_PLAN',
  LOAD_COMPANY_QUOTA: 'SUBSCRIPTION_LOAD_COMPANY_QUOTA',
  LOAD_SUBSCRIPTION: 'SUBSCRIPTION_LOAD_COMPANY_SUBSCRIPTION',
  LOAD_SETTINGS: 'SUBSCRIPTION_LOAD_SETTINGS',
  UPDATE_SETTINGS: 'UPDATE_SETTINGS',
  UPDATE_ACCOUNTING_SUBSCRIPTION: 'UPDATE_ACCOUNTING_SUBSCRIPTION',
  LOAD_INVOICES: 'SUBSCRIPTION_LOAD_INVOICE_RECIPES',
  ALREADY_SUBSCRIBED: 'SUBSCRIPTION_ALREADY_ACTIVE',
  UPDATE_PAYMENT_TOKEN: 'SUBSCRIPTION_UPDATE_TOKEN',
  PAY_INVOICES: 'SUBSCRIPTION_PAY_INVOICES',
  UPDATE_PAYMENT_ERROR: 'UPDATE_PAYMENT_ERROR',
  PAYMENT_DECLINED: 'SUBSCRIPTION_CARD_DECLINED',
  CLEAR_ERROR: 'SUBSCRIPTION_CLEAR_ERROR',
  CANCEL_SUBSCRIPTION: 'SUBSCRIPTION_CANCEL',
  CANCEL_FAILED: 'SUBSCRIPTION_CANCEL_FAILED',
  COUPON: {
    GET: 'SUBSCRIPTION_GET_COUPON',
    FAILED: 'SUBSCRIPTION_GET_COUPON_FAILED',
    CLEAR: 'SUBSCRIPTION_CLEAR_COUPON',
  },
}

export const UserActions = {
  GET_USER: 'GET_USER',
  UPDATE_USERNAME: 'UPDATE_USERNAME',
}

export const ErrorActions = {
  ADD_ERROR: 'ERROR_ADD',
  REMOVE_ERROR: 'ERROR_REMOVE',
}

export const FinancingActionTypes = {
  FINANCING_PROVIDER_REQUEST: 'FINANCING_PROVIDER_REQUEST',
  GET_KYC_TOKEN__SUCCESS: 'GET_KYC_TOKEN__SUCCESS',
  FINEXKAP: {
    LOADED: 'FINEXKAP_LOADED',
    COMPANY: {
      CHECK_ELIGIBILITY: 'FINEXKAP_COMPANY_CHECK_ELIGIBILITY',
      CHECK_ACCOUNT_EXISTS: 'FINEXKAP_COMPANY_CHECK_ACCOUNT_EXISTS',
    },
  },
  SET_AGERAS_ESTIMATE: 'SET_AGERAS_ESTIMATE',
  SET_AGERAS_KYC_URL: 'SET_AGERAS_KYC_URL',
  SET_AGERAS_LOAN_KYC_URL: 'SET_AGERAS_LOAN_KYC_URL',
  SET_AGERAS_LOAN: 'SET_AGERAS_LOAN',
}

export const PayNowActions = {
  SAVE_AUTHORIZATION: 'PAYNOW_SAVE_AUTHORIZATION',
  LOAD_STATUS: 'PAYNOW_LOAD_STATUS',
  UPDATE_STATUS_TOGGLE_ACTIVE: 'PAYNOW_UPDATE_STATUS_TOGGLE_ACTIVE',
  DISCONNECT: 'PAYNOW_DISCONNECT',
}

export const AgerasMarketplaceActions = {
  LOAD_TOKEN: 'MARKETPLACE_LOAD_TOKEN',
  SAVE_TOKEN: 'MARKETPLACE_SAVE_TOKEN',
  LOAD_PHONE: 'MARKETPLACE_LOAD_PHONE',
  SAVE_RESPONSE_ID: 'MARKETPLACE_SAVE_RESPONSE_ID',
  REQUEST_VERIFICATION: 'MARKETPLACE_REQUEST_VERIFICATION',
  SUBMIT_VERIFICATION: 'MARKETPLACE_SUBMIT_VERIFICATION',
}

export const InvoiceActions = {
  DELETE_INVOICE: 'DELETE_INVOICE',
  SAVE_INVOICE: 'SAVE_INVOICE',
  EDIT_INVOICE: 'EDIT_INVOICE',
  GET_INVOICE: 'GET_INVOICE',
  COPY_INVOICE: 'COPY_INVOICE',
  SET_INVOICE: 'SET_INVOICE',
}

export const EstimateActions = {
  DELETE_ESTIMATE: 'DELETE_ESTIMATE',
  SAVE_ESTIMATE: 'SAVE_ESTIMATE',
  EDIT_ESTIMATE: 'EDIT_ESTIMATE',
  GET_ESTIMATE: 'GET_ESTIMATE',
  COPY_ESTIMATE: 'COPY_ESTIMATE',
  SET_ESTIMATE: 'SET_ESTIMATE',
}

export const DraftActions = {
  UPDATE_DRAFT_COMPANY_FROM_SETTINGS: 'UPDATE_DRAFT_COMPANY_FROM_SETTINGS',
  UPDATE_DRAFT_STYLES_FROM_SETTINGS: 'UPDATE_DRAFT_STYLES_FROM_SETTINGS',
  UPDATE_DRAFT_COMPANY_FROM_COMPANY: 'UPDATE_DRAFT_COMPANY_FROM_COMPANY',
  UPDATE_DRAFT_FIELDS_FROM_SETTINGS: 'UPDATE_DRAFT_FIELDS_FROM_SETTINGS',
  REPLACE_PAYMENT_METHODS_FROM_SETTINGS: 'REPLACE_PAYMENT_METHODS_FROM_SETTINGS',
  UPDATE_DRAFT_CUSTOMER: 'UPDATE_DRAFT_CUSTOMER',
  LOAD_DRAFT: 'LOAD_DRAFT',
  COPY_DRAFT: 'COPY_DRAFT',
  PREVIEW_DRAFT: 'PREVIEW_DRAFT',
  PREVIEW_DOCUMENT: 'PREVIEW_DOCUMENT',
  DELETE_ORDER: 'DELETE_ORDER',
  UPDATE_ORDER: 'UPDATE_ORDER',
  UPDATE_ESTIMATE_NUMBER: 'UPDATE_ESTIMATE_NUMBER',
  CREATE_INVOICE_DRAFT: 'CREATE_INVOICE_DRAFT',
  UPDATE_INVOICE_DRAFT: 'UPDATE_INVOICE_DRAFT',
  CREATE_ESTIMATE_DRAFT: 'CREATE_ESTIMATE_DRAFT',
  UPDATE_ESTIMATE_DRAFT: 'UPDATE_ESTIMATE_DRAFT',
  UPDATE_PAYMENT_REFERENCE_TYPE_FROM_SETTINGS: 'UPDATE_PAYMENT_REFERENCE_TYPE_FROM_SETTINGS',
  UPDATE_CUSTOMER_NUMBER_FROM_SETTINGS: 'UPDATE_CUSTOMER_NUMBER_FROM_SETTINGS',
  UPDATE_INVOICE_COLUMNS_FROM_INVOICE_TYPE: 'UPDATE_INVOICE_COLUMNS_FROM_INVOICE_TYPE',
  UPDATE_DRAFT_CUSTOMER_FROM_CUSTOMERS: 'UPDATE_DRAFT_CUSTOMER_FROM_CUSTOMERS',
  GET_VALIDATION_FIELDS: 'GET_VALIDATION_FIELDS',
}

export const ReminderActions = {
  SEND_REMINDER_EMAIL: 'SEND_REMINDER_EMAIL',
  SEND_REMINDER_POST: 'SEND_REMINDER_POST',
  UPDATE_REMINDER_SETTINGS: 'UPDATE_REMINDER_SETTINGS',
  LOAD_REMINDER_SETTINGS: 'LOAD_REMINDER_SETTINGS',
}

export const TrackerActions = {
  LOAD_TRACKER_ENTRIES: 'LOAD_TRACKER_ENTRIES',
  UPDATE_TRACKER_ENTRY: 'UPDATE_TRACKER_ENTRY',
  CREATE_TRACKER_ENTRY: 'CREATE_TRACKER_ENTRY',
  DELETE_TRACKER_ENTRIES: 'DELETE_TRACKER_ENTRIES',
}

export const CustomSettingsActions = {
  UPDATE_CUSTOM_SETTINGS: 'UPDATE_CUSTOM_SETTINGS',
  LOAD_CUSTOM_SETTINGS: 'LOAD_CUSTOM_SETTINGS',
}

export const ExperimentActions = {
  LOAD_EXPERIMENTS: 'LOAD_EXPERIMENTS',
}

export const ProductActions = {
  LOAD_PRODUCTS: 'GET_PRODUCTS',
  GET_PRODUCT: 'GET_PRODUCT',
  CREATE_PRODUCT: 'CREATE_PRODUCT',
  UPDATE_PRODUCT: 'UPDATE_PRODUCT',
  UPDATE_PRODUCTS: 'UPDATE_PRODUCTS',
  DELETE_PRODUCT: 'DELETE_PRODUCT',
  DELETE_PRODUCTS: 'DELETE_PRODUCTS',
}

export const CustomerActions = {
  GET_ALL_CUSTOMERS: 'GET_ALL_CUSTOMERS',
  GET_CUSTOMERS: 'GET_CUSTOMERS',
  GET_CUSTOMER_BY_ID: 'GET_CUSTOMER_BY_ID',
  CREATE_CUSTOMER: 'CREATE_CUSTOMER',
  UPDATE_CUSTOMER: 'UPDATE_CUSTOMER',
  DELETE_CUSTOMER: 'DELETE_CUSTOMER',
  CREATE_CUSTOMER_FAILED: 'CREATE_CUSTOMER_FAILED',
  UPDATE_CUSTOMER_FAILED: 'UPDATE_CUSTOMER_FAILED',
  RESET_CUSTOMER: 'RESET_CUSTOMER',
}

export const RecurringProfileActions = {
  DELETE_RECURRING_PROFILE_SETTINGS: 'DELETE_RECURRING_PROFILE_SETTINGS',
  UPDATE_RECURRING_PROFILE_SETTINGS: 'UPDATE_RECURRING_PROFILE_SETTINGS',
  CREATE_RECURRING_PROFILE: 'SAVE_RECURRING_PROFILE',
  UPDATE_RECURRING_PROFILE: 'SAVE_RECURRING_PROFILE',
  DELETE_RECURRING_PROFILE: 'DELETE_RECURRING_PROFILE',
  GET_RECURRING_PROFILES: 'GET_RECURRING_PROFILES',
  GET_RECURRING_PROFILE: 'GET_RECURRING_PROFILE',
}

export const DeliveryActions = {
  VALIDATE_EINVOICE_ADDRESS: 'DELIVERY_VALIDATE_EINVOICE_ADDRESS',
  VALIDATE_ADDRESS: 'DELIVERY_VALIDATE_ADDRESS',
}

export const TokenActions = {
  UPDATE_TOKEN: 'UPDATE_TOKEN',
  CHANGE_LOCALE: 'CHANGE_LOCALE',
}

export const ReferralActions = {
  LOAD_REFERRALS: 'LOAD_REFERRALS',
}

export const ReportsActions = {
  LOAD_SALES: 'LOAD_SALES',
  LOAD_TRANSACTIONS: 'LOAD_TRANSACTIONS',
  LOAD_PRE_ACCOUNTING: 'LOAD_PRE_ACCOUNTING',
  LOAD_SALES_BY_CUSTOMER: 'LOAD_SALES_BY_CUSTOMER',
  LOAD_ALL_SALES_BY_CUSTOMER: 'LOAD_ALL_SALES_BY_CUSTOMER',
  LOAD_SALES_BY_PRODUCT: 'LOAD_SALES_BY_PRODUCT',
  UPDATE_SETTINGS: 'UPDATE_SETTINGS',
  INITIATE_EXPENSES_ZIP: 'INITIATE_EXPENSES_ZIP',
  DOWNLOAD_EXPENSES_ZIP: 'DOWNLOAD_EXPENSES_ZIP',
}

export const DraftV1Actions = {
  DRAFT_V1_CHANGE_CUSTOMER: 'DRAFT_V1_CHANGE_CUSTOMER',
  DRAFT_V1_CHANGE_COMPANY: 'DRAFT_V1_CHANGE_COMPANY',
  DRAFT_V1_CHANGE_DELIVERYNOTE_NUMBER: 'DRAFT_V1_CHANGE_DELIVERYNOTE_NUMBER',
  DRAFT_V1_CHANGE_RECEIPT_NUMBER: 'DRAFT_V1_CHANGE_RECEIPT_NUMBER',
  DRAFT_V1_CHANGE_INVOICE_NUMBER: 'DRAFT_V1_CHANGE_INVOICE_NUMBER',
  DRAFT_V1_LOAD_NEW: 'DRAFT_V1_LOAD_NEW',
  DRAFT_V1_LOAD: 'DRAFT_V1_LOAD',
  DRAFT_V1_LOAD_APPROVED: 'DRAFT_V1_LOAD_APPROVED',
  DRAFT_V1_CHANGE_TITLE: 'DRAFT_V1_CHANGE_TITLE',
  DRAFT_V1_CLEAR: 'DRAFT_V1_CLEAR',
  DRAFT_V1_CLEAN_DIRTY: 'DRAFT_V1_CLEAN_DIRTY',
  DRAFT_V1_CHANGE_LINES: 'DRAFT_V1_CHANGE_LINES',
  DRAFT_V1_ADD_PRODUCT_LINE: 'DRAFT_V1_ADD_PRODUCT_LINE',
  DRAFT_V1_CHANGE_COLUMNS_CONFIG: 'DRAFT_V1_CHANGE_COLUMNS_CONFIG',
  DRAFT_V1_CHANGE_LANGUAGE: 'DRAFT_V1_CHANGE_LANGUAGE',
  DRAFT_V1_CHANGE_CURRENCY: 'DRAFT_V1_CHANGE_CURRENCY',
  DRAFT_V1_CHANGE_EXCHANGE_RATE: 'DRAFT_V1_CHANGE_EXCHANGE_RATE',
  DRAFT_V1_CHANGE_FOOTER_TEXT: 'DRAFT_V1_CHANGE_FOOTER_TEXT',
  DRAFT_V1_SAVE_DRAFT: 'DRAFT_V1_SAVE_DRAFT',
  DRAFT_V1_UPDATE_DRAFT: 'DRAFT_V1_UPDATE_DRAFT',
  DRAFT_V1_UPDATE_APPROVED: 'DRAFT_V1_UPDATE_APPROVED',
  DRAFT_V1_PREVIEW: 'DRAFT_V1_PREVIEW',
  DRAFT_V1_CLEAR_PREVIEW: 'DRAFT_V1_CLEAR_PREVIEW',
  DRAFT_V1_CHANGE_DRAFT_INVALID_FIELDS: 'DRAFT_V1_CHANGE_DRAFT_INVALID_FIELDS',
  DRAFT_V1_CHANGE_DESCRIPTION: 'DRAFT_V1_CHANGE_DESCRIPTION',
  DRAFT_V1_CHANGE_ISSUE_DATE: 'DRAFT_V1_CHANGE_ISSUE_DATE',
  DRAFT_V1_CHANGE_DISCOUNT_AMOUNT: 'DRAFT_V1_CHANGE_DISCOUNT_AMOUNT',
  DRAFT_V1_CHANGE_DISCOUNT_VAT: 'DRAFT_V1_CHANGE_DISCOUNT_VAT',
  DRAFT_V1_CHANGE_DISCOUNT_TYPE: 'DRAFT_V1_CHANGE_DISCOUNT_TYPE',
  DRAFT_V1_CHANGE_DISCOUNT_ENABLED: 'DRAFT_V1_CHANGE_DISCOUNT_ENABLED',
  DRAFT_V1_CHANGE_DISCOUNT_LOCATION: 'DRAFT_V1_CHANGE_DISCOUNT_LOCATION',
  DRAFT_V1_COPY: 'DRAFT_V1_COPY',
  DRAFT_V1_COPY_APPROVED: 'DRAFT_V1_COPY_APPROVED',
}

export const CompanyActions = {
  UPDATE_VAT_NUMBER_VALIDATION: 'UPDATE_VAT_NUMBER_VALIDATION',
}

export const ExpenseAction = {
  GET_EXPENSES: 'GET_EXPENSES',
  UPDATE_EXPENSE: 'UPDATE_EXPENSE',
  SAVE_EXPENSE: 'SAVE_EXPENSE',
  DELETE_EXPENSE: 'DELETE_EXPENSE',
  UNDELETE_EXPENSE: 'UNDELETE_EXPENSE',
  RESTORE_ALL_EXPENSES: 'RESTORE_ALL_EXPENSES',
  RESET_EXPENSES: 'RESET_EXPENSES',
  GET_ATTACHMENT: 'GET_ATTACHMENT',
  GET_ATTACHMENT_UPLOAD_LINK: 'GET_ATTACHMENT_UPLOAD_LINK',
  SAVE_ATTACHMENT: 'SAVE_ATTACHMENT',
  UPLOAD_ATTACHMENT: 'UPLOAD_ATTACHMENT',
  DELETE_ATTACHMENT: 'DELETE_ATTACHMENT',
  ATTACHMENT_LOADING: 'ATTACHMENT_LOADING',
  SET_LOADING: 'SET_LOADING',
  GET_REPORT_SUMMARY: 'GET_REPORT_SUMMARY',
  DELETE_ALL_EXPENSES: 'DELETE_ALL_EXPENSES',
}

export const ExternalBillyActions = {
  GET_EXTERNAL_TAX_RATES: 'GET_EXTERNAL_TAX_RATES',
}
